'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Проксираем доступ к localStorage
// Если не доступен localStorage или на серве,
// то запись ведется в простой объект

var LocalStorageProxy = function () {
  function LocalStorageProxy() {
    var _this = this;

    (0, _classCallCheck3.default)(this, LocalStorageProxy);
    this._storage = {};

    var store = require('store');
    // if (__CLIENT__) {
    try {
      window.localStorage.setItem('__TEST__', 1);
      window.localStorage.getItem('__TEST__');
      window.localStorage.removeItem('__TEST__');
      this._storage = window.localStorage;
      this.setItem = function (key, value) {
        return _this._storage.setItem(key, value);
      };

      if (!(typeof this.setItem === 'function')) {
        throw new TypeError('Value of "this.setItem" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(this.setItem));
      }

      this.getItem = function (key) {
        return _this._storage.getItem(key);
      };

      if (!(typeof this.getItem === 'function')) {
        throw new TypeError('Value of "this.getItem" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(this.getItem));
      }

      this.removeItem = function (key) {
        return _this._storage.removeItem(key);
      };

      if (!(typeof this.removeItem === 'function')) {
        throw new TypeError('Value of "this.removeItem" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(this.removeItem));
      }

      this.clear = function () {
        return _this._storage.clear();
      };

      if (!(typeof this.clear === 'function')) {
        throw new TypeError('Value of "this.clear" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(this.clear));
      }
    } catch (e) {
      this._storage = store;
      this.setItem = function (key, value) {
        return _this._storage.set(key, value);
      };

      if (!(typeof this.setItem === 'function')) {
        throw new TypeError('Value of "this.setItem" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(this.setItem));
      }

      this.getItem = function (key) {
        return _this._storage.get(key);
      };

      if (!(typeof this.getItem === 'function')) {
        throw new TypeError('Value of "this.getItem" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(this.getItem));
      }

      this.removeItem = function (key) {
        return _this._storage.remove(key);
      };

      if (!(typeof this.removeItem === 'function')) {
        throw new TypeError('Value of "this.removeItem" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(this.removeItem));
      }

      this.clear = function () {
        return _this._storage.clearAll();
      };

      if (!(typeof this.clear === 'function')) {
        throw new TypeError('Value of "this.clear" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(this.clear));
      }
    }
    // }
  }

  (0, _createClass3.default)(LocalStorageProxy, [{
    key: 'setItem',
    value: function setItem(key, value) {
      this._storage[key] = this._toString(value);
    }
  }, {
    key: 'getItem',
    value: function getItem(key) {
      return this._storage[key] === undefined ? null : this._storage[key];
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key) {
      delete this._storage[key];
    }
  }, {
    key: 'clear',
    value: function clear() {
      this._storage = {};
    }
  }, {
    key: '_toString',
    value: function _toString(value) {
      return typeof value !== 'string' ? (0, _stringify2.default)(value) : value;
    }
  }]);
  return LocalStorageProxy;
}();

var storage = new LocalStorageProxy();
exports.default = storage;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/ibonus/LocalStorageProxy.js
// module id = 45
// module chunks = 0